import React from 'react';
import { Input } from 'antd';
import Visibility from '@/assets/visibility.svg?react';
import VisibilityOff from '@/assets/visibility-off.svg?react';

const { Password } = Input;

const EPInputPassword = props => {
  return <Password size="large" {...props} iconRender={visible => (visible ? <Visibility /> : <VisibilityOff />)} />;
};

export default EPInputPassword;
